import { render, staticRenderFns } from "./ExternalContentView.vue?vue&type=template&id=2c20c233&scoped=true"
import script from "./ExternalContentView.vue?vue&type=script&lang=js"
export * from "./ExternalContentView.vue?vue&type=script&lang=js"
import style0 from "./ExternalContentView.vue?vue&type=style&index=0&id=2c20c233&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c20c233",
  null
  
)

export default component.exports